import React, { useEffect,useState } from 'react'
import { Link, useParams,useNavigate } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import $ from 'jquery';
import { useCSVDownloader } from 'react-papaparse';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';
import { parseValue } from '../utils/Common';
import moment from 'moment';
import Table from './common/Table';
const common = require('../utils/Common');

const BuyerCommission = () => {
    let navigate = useNavigate();
    const { CSVDownloader } = useCSVDownloader();

    const [userCommissions, setUserCommissions] = useState([]);
    const [paymentList, setPaymentList] = useState([]);
    const [approveButton, setApproveButton] = useState(false);
    const [pushPaymentButton, setPushPaymentButton] = useState(false);
    const [modal, setModal] = useState(false);
    const [orderDetails, setOrderDetails] = useState([]);
    const [commissionPercentOnlineProduct, setCommissionPercentOnlineProduct] = useState(0);
    const [commissionPercentOfflineProduct, setCommissionPercentOfflineProduct] = useState(0);
    const [commissionPercentService, setCommissionPercentService] = useState(0);
    const [tdsPercent, setTdsPercent] = useState(0);
    const [orderDetailsType, setOrderDetailsType] = useState(null);
    const [commissionType, setCommissionType] = useState('sale_retail');
    const [allChecked, setAllChecked] = useState(0);
    const [addPaymentDate, setAddPaymentDate] = useState(false);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});

    useEffect(()=>{
        checkAccess();
    },[])

    const checkAccess = async () => {
        let rights = await common.checkAccessRights(window.location.pathname);
        if (!rights.view) {
          alert("Access Denied");
          navigate("/");
          return;
        } else {
          setUserRights(rights);
        }
    }
    
	const fetchUserCommissions = async () => {
    setUserCommissions([]);
    if (!$('#start_date').val() || !$('#end_date').val() || !$('#commission_type').val()) {
        alert("Fill all filters (Start Date, End Date & Commission Type)");
        return;
    }
    setCommissionType($('#commission_type').val());
    let fetchType = 0;
    if ($('#fetch_approved').is(':checked')) {
      fetchType = 1;
    } else if ($('#fetch_done_payments').is(':checked')) {
      fetchType = 2;
    }
    const data = {
        start_date: $('#start_date').val(),
        end_date: $('#end_date').val(),
        fetch_approved: fetchType,
        retainer_commission: $('#commission_type').val() == "retainer" ? 1 : 0
    }
		let response = await common.apiRequest('post', '/admin/fetch-user-commission', data);
		if (response.status == 200) {
			if (response.data.code == 'success') {
                setUserCommissions(response.data.data);
			} else {
                alert(response.data.error);
            }
		} else {
            alert(response.data.error);
		}
	}

    
    const addToPaymentList = (selectedRows) => {
        let markAsPaid = $('#fetch_approved').is(':checked') ? 1 : 0;
        let list = [];
        
        if (selectedRows?.length > 0) {
            list = selectedRows;
            if (markAsPaid) {
              setPushPaymentButton(true);
              setApproveButton(false);
            } else {
              setPushPaymentButton(false);
              setApproveButton(true);
            }
            $('#start_date').prop('disabled', true);
            $('#end_date').prop('disabled', true);
            $('#commission_type').prop('disabled', true);
            $('#all').prop('disabled', true);
            $('#fetch_approved').prop('disabled', true);
            $('#fetch_done_payments').prop('disabled', true);
            $('#submit_button').prop('disabled', true);
        } else {
            setApproveButton(false);
            setPushPaymentButton(false);
            $('#start_date').prop('disabled', false);
            $('#end_date').prop('disabled', false);
            $('#commission_type').prop('disabled', false);
            $('#all').prop('disabled', false);
            $('#fetch_approved').prop('disabled', false);
            $('#fetch_done_payments').prop('disabled', false);
            $('#submit_button').prop('disabled', false);
        }
        
        setPaymentList(list);
    };
    
    const approvePayment = async () => {
      $('#approve-button').prop('disabled', true);
      let finalData = {
          "action": "create",
          "commission_type": $('#commission_type').val(),
          "data": paymentList
      }
      let response = await common.apiRequest('post', '/admin/crud-buyer-payment', finalData);
      if (response.status == 200) {
        if (response.data.code == 'success') {
          alert(response.data.message);
          setApproveButton(false);
          setPaymentList([]);
          setModal(false);
          setAllChecked(0);
          $('input[type="checkbox"]').prop('checked', false);
          $('#start_date').prop('disabled', false);
          $('#end_date').prop('disabled', false);
          $('#commission_type').prop('disabled', false);
          $('#fetch_approved').prop('disabled', false);
          $('#fetch_done_payments').prop('disabled', false);
          $('#submit_button').prop('disabled', false);
          fetchUserCommissions();
        } else {
          alert(response.data.error);
        }
      } else {
        alert(response.data.error);
      }
      $('#approve-button').prop('disabled', false);
    }

    const updatePaymentDate = async () => {
      $('#push-payment-button').prop('disabled', true);
      let orderItemIdsShopping = [], orderItemIdsRetail = [], orderItemIdsRetainer = [];
      for (const list of paymentList) {
        if (list.order_item_ids_shopping) {
          orderItemIdsShopping = orderItemIdsShopping.concat(list.order_item_ids_shopping.split(","));
        }
        if (list.order_item_ids_retail) {
          orderItemIdsRetail = orderItemIdsRetail.concat(list.order_item_ids_retail.split(","));
        }
        if (list.order_item_ids) {
          orderItemIdsRetainer = orderItemIdsRetainer.concat(list.order_item_ids.split(","));
        }
      }
      let finalData = {
          "action": "update",
          "payment_date": moment($('#payment-date').val()).format("YYYY-MM-DD HH:mm:ss"),
          "order_item_ids_shopping": orderItemIdsShopping,
          "order_item_ids_retail": orderItemIdsRetail,
          "order_item_ids_retainer": orderItemIdsRetainer,
          "type": $('#commission_type').val()
      }
      let response = await common.apiRequest('post', '/admin/update-payment-date', finalData);
      if (response.status == 200) {
        if (response.data.code == 'success') {
          alert(response.data.message);
          setPushPaymentButton(false);
          setPaymentList([]);
          setAddPaymentDate(!addPaymentDate);
          setAllChecked(0);
          $('input[type="checkbox"]').prop('checked', false);
          $('#start_date').prop('disabled', false);
          $('#end_date').prop('disabled', false);
          $('#commission_type').prop('disabled', false);
          $('#fetch_approved').prop('disabled', false);
          $('#fetch_done_payments').prop('disabled', false);
          $('#submit_button').prop('disabled', false);
          fetchUserCommissions();
        } else {
          alert(response.data.error);
        }
      } else {
        alert(response.data.error);
      }
      $('#push-payment-button').prop('disabled', false);
    }

    const toggle = () => {
        setModal(!modal);
        setOrderDetails([]);
        setCommissionPercentOnlineProduct(0);
        setCommissionPercentOfflineProduct(0);
        setCommissionPercentService(0);
        setTdsPercent(0);
        setOrderDetailsType(null);
    }

    const getOrderDetails = async (orderIds, commissionPercentOnlineProduct, commissionPercentOfflineProduct, commissionPercentService, type, tds) => {
        let data = {
            'ids': orderIds,
        }
        let response = await common.apiRequest('post', '/orders/get-order-by-order-id', data);
		if (response.status == 200) {
			if (response.data.code == 'success') {
                setOrderDetails(response.data.data);
                setModal(true);
                setCommissionPercentOnlineProduct(commissionPercentOnlineProduct);
                setCommissionPercentOfflineProduct(commissionPercentOfflineProduct);
                setCommissionPercentService(commissionPercentService);
                setTdsPercent(tds);
                setOrderDetailsType(type);
			} else {
                alert(response.data.error);
            }
		} else {
            alert(response.data.error);
		}
    }

    const retainerColumnDefsdata = userCommissions.map((item, index) => ({
      "S.No": index + 1,
      reg_id: item.reg_id,
      first_name: item.first_name,
      middle_name: item.middle_name,
      last_name: item.last_name,
      bank_account_no: item.bank_account_no || "",
      bank_name: item.bank_name || "",
      ifsc_code: item.ifsc_code || "",
      retainer_total_order_amount_online: parseValue(item.retainer_total_order_amount_online, 'float'),
      retainer_total_taxable_order_amount_online: parseValue(item.retainer_total_taxable_order_amount_online, 'float'),
      retainer_total_order_amount_offline: parseValue(item.retainer_total_order_amount_offline, 'float'),
      retainer_total_taxable_order_amount_offline: parseValue(item.retainer_total_taxable_order_amount_offline, 'float'),
      retainer_total_order_amount_service: parseValue(item.retainer_total_order_amount_service, 'float'),
      retainer_total_taxable_order_amount_service: parseValue(item.retainer_total_taxable_order_amount_service, 'float'),
      refer_reg_id: item.refer_reg_id,
      refer_first_name: item.refer_first_name,
      refer_middle_name: item.refer_middle_name,
      refer_last_name: item.refer_last_name,
      retainer_order_amount_online: parseValue(item.retainer_order_amount_online, 'float'),
      retainer_taxable_order_amount_online: parseValue(item.retainer_taxable_order_amount_online, 'float'),
      retainer_commission_percent_online: parseValue(item.retainer_commission_percent_online, 'float'),
      retainer_commission_online: parseValue(item.retainer_commission_online, 'float'),
      retainer_order_amount_offline: parseValue(item.retainer_order_amount_offline, 'float'),
      retainer_taxable_order_amount_offline: parseValue(item.retainer_taxable_order_amount_offline, 'float'),
      retainer_commission_percent_offline: parseValue(item.retainer_commission_percent_offline, 'float'),
      retainer_commission_offline: parseValue(item.retainer_commission_offline, 'float'),
      retainer_order_amount_service: parseValue(item.retainer_order_amount_service, 'float'),
      retainer_taxable_order_amount_service: parseValue(item.retainer_taxable_order_amount_service, 'float'),
      retainer_commission_percent_service: parseValue(item.retainer_commission_percent_service, 'float'),
      retainer_commission_service: parseValue(item.retainer_commission_service, 'float'),
      total_commission: parseValue(
          (
              parseFloat(item.retainer_commission_online || 0) +
              parseFloat(item.retainer_commission_offline || 0) +
              parseFloat(item.retainer_commission_service || 0)
          ).toFixed(2),
          'float'
      ),
      tds: parseValue(
        (
            (parseFloat(item.retainer_commission_online) || 0) +
            (parseFloat(item.retainer_commission_offline) || 0) +
            (parseFloat(item.retainer_commission_service) || 0)
        ) * item.tds_percent, 
        'float'
      ),
      receivable_commission: parseValue(
          (
              parseFloat(item.retainer_commission_online || 0) +
              parseFloat(item.retainer_commission_offline || 0) +
              parseFloat(item.retainer_commission_service || 0) -
              (
                  (
                      parseFloat(item.retainer_commission_online || 0) +
                      parseFloat(item.retainer_commission_offline || 0) +
                      parseFloat(item.retainer_commission_service || 0)
                  ) * item.tds_percent
              )
          ).toFixed(2),
          'float'
      )
  }));
  
  const saleRetailColumnDefsdata = userCommissions.map((user, index) => ({
      "S.No": index + 1,
      reg_id: user.reg_id || "",
      first_name: user.first_name || "",
      middle_name: user.middle_name || "",
      last_name: user.last_name || "",
      bank_account_no: user.bank_account_no || "",
      bank_name: user.bank_name || "",
      ifsc_code: user.ifsc_code || "",
      total_user_shopping_amount_taxable: parseValue(user.total_user_shopping_amount_taxable, 'float'),
      variant: user.variant || "",
      total_shopping_online_product: parseValue(user.total_shopping_online_product, 'float'),
      total_taxable_shopping_online_product: parseValue(user.total_taxable_shopping_online_product, 'float'),
      commission_percent_online_product: parseValue(user.commission_percent_online_product, 'float'),
      total_shopping_offline_product: parseValue(user.total_shopping_offline_product, 'float'),
      total_taxable_shopping_offline_product: parseValue(user.total_taxable_shopping_offline_product, 'float'),
      commission_percent_offline_product: parseValue(user.commission_percent_offline_product, 'float'),
      total_shopping_service: parseValue(user.total_shopping_service, 'float'),
      total_taxable_shopping_service: parseValue(user.total_taxable_shopping_service, 'float'),
      commission_percent_service: parseValue(user.commission_percent_service, 'float'),
      ref_user_reg_id: user.ref_user_reg_id || "",
      total_order_amount_shopping_online_product: parseValue(user.total_order_amount_shopping_online_product, 'float'),
      total_taxable_amount_shopping_online_product: parseValue(user.total_taxable_amount_shopping_online_product, 'float'),
      commission_shopping_online_product: parseValue(user.commission_shopping_online_product, 'float'),
      total_order_amount_shopping_offline_product: parseValue(user.total_order_amount_shopping_offline_product, 'float'),
      total_taxable_amount_shopping_offline_product: parseValue(user.total_taxable_amount_shopping_offline_product, 'float'),
      commission_shopping_offline_product: parseValue(user.commission_shopping_offline_product, 'float'),
      total_order_amount_shopping_service: parseValue(user.total_order_amount_shopping_service, 'float'),
      total_taxable_amount_shopping_service: parseValue(user.total_taxable_amount_shopping_service, 'float'),
      commission_shopping_service: parseValue(user.commission_shopping_service, 'float'),
      shopping_tds: parseValue(
          (
              (parseFloat(user.commission_shopping_online_product) || 0) +
              (parseFloat(user.commission_shopping_offline_product) || 0) +
              (parseFloat(user.commission_shopping_service) || 0)
          ) * user.tds_percent, 
          'float'
      ),
      shopping_receiveable: parseValue(
          (
              (parseFloat(user.commission_shopping_online_product) || 0) +
              (parseFloat(user.commission_shopping_offline_product) || 0) +
              (parseFloat(user.commission_shopping_service) || 0) -
              (
                  ((parseFloat(user.commission_shopping_online_product) || 0) +
                  (parseFloat(user.commission_shopping_offline_product) || 0) +
                  (parseFloat(user.commission_shopping_service) || 0)) * user.tds_percent
              )
          ).toFixed(2), 
          'float'
      ),
      total_order_amount_retail_online_product: parseValue(user.total_order_amount_retail_online_product, 'float'),
      total_taxable_amount_retail_online_product: parseValue(user.total_taxable_amount_retail_online_product, 'float'),
      commission_percent_retail_online_product: parseValue(user.commission_percent_retail_online_product, 'float'),
      commission_retail_online_product: parseValue(user.commission_retail_online_product, 'float'),
      total_order_amount_retail_offline_product: parseValue(user.total_order_amount_retail_offline_product, 'float'),
      total_taxable_amount_retail_offline_product: parseValue(user.total_taxable_amount_retail_offline_product, 'float'),
      commission_percent_retail_offline_product: parseValue(user.commission_percent_retail_offline_product, 'float'),
      commission_retail_offline_product: parseValue(user.commission_retail_offline_product, 'float'),
      total_order_amount_retail_service: parseValue(user.total_order_amount_retail_service, 'float'),
      total_taxable_amount_retail_service: parseValue(user.total_taxable_amount_retail_service, 'float'),
      commission_percent_retail_service: parseValue(user.commission_percent_retail_service, 'float'),
      commission_retail_service: parseValue(user.commission_retail_service, 'float'),
      retail_tds: parseValue(
          (
              (parseFloat(user.commission_retail_online_product) || 0) +
              (parseFloat(user.commission_retail_offline_product) || 0) +
              (parseFloat(user.commission_retail_service) || 0)
          ) * user.tds_percent, 
          'float'
      ),
      retail_receiveable: parseValue(
          (
              (parseFloat(user.commission_retail_online_product) || 0) +
              (parseFloat(user.commission_retail_offline_product) || 0) +
              (parseFloat(user.commission_retail_service) || 0) -
              (
                  ((parseFloat(user.commission_retail_online_product) || 0) +
                  (parseFloat(user.commission_retail_offline_product) || 0) +
                  (parseFloat(user.commission_retail_service) || 0)) * user.tds_percent
              )
          ).toFixed(2), 
          'float'
      )
  }));
    const rowHeight = 80;

    const safeDivide = (num, denom) => denom > 0 ? num / denom : 0;
    const safeNumber = val => Number(val) || 0;
    
    const dataOther = orderDetails.map((data, index) => {
      const onlineTaxableAmount = data.product_id ? safeNumber(data.taxable_amount) : 0;
      const offlineTaxableAmount = data.offline_sale_id && data.offline_sale_product_datum 
          ? safeNumber(data.offline_sale_product_datum.taxable_supply) 
          : 0;
      const serviceTaxableAmount = data.service_id ? safeNumber(data.taxable_amount) : 0;
  
      const logisticsOrder = data.logistics_order || data?.logistics_orders?.[0] || {};
      const logisticsItemCount = logisticsOrder?.order_item_id?.split(',')?.length || 0;
      const logisticsTaxableAmount = safeDivide(safeNumber(logisticsOrder.taxable_value), logisticsItemCount);
      const logisticsOrderAmount = safeDivide(safeNumber(logisticsOrder.order_price), logisticsItemCount);
  
      // Calculate commissions
      const onlineCommission = onlineTaxableAmount * commissionPercentOnlineProduct / 100;
      const offlineCommission = offlineTaxableAmount * commissionPercentOfflineProduct / 100;
      const serviceCommission = serviceTaxableAmount * commissionPercentService / 100;
      const logisticsCommission = logisticsTaxableAmount * commissionPercentService / 100;
  
      const totalCommission = onlineCommission + offlineCommission + serviceCommission + logisticsCommission;
      const tds = totalCommission * tdsPercent;
      const netReceivable = totalCommission - tds;
  
      return {
          "S.No": index + 1,
          "Order Id": data.order?.order_id || 'NA',
          'Reg Id': data.order?.user?.reg_id || 'NA',
          "Order Date": data.order?.created_at || 'NA',
          "Invoice No": data.order?.invoices?.find(invoice =>
              invoice.invoice_type === (["shopping", "retainer"].includes(orderDetailsType) ? 'product' : 'seller_product')
          )?.invoice_no || 'NA',
          "No Return Date": data?.no_return_date || null,
          "Product/Service Name": data.product_item?.product?.name 
                                  || data.offline_sale_product_datum?.product_description 
                                  || data.seller_service?.service_name 
                                  || 'NA',
          "Online Sale Amount": data.product_id ? safeNumber(data.order_price) : 0,
          "Online Taxable Amount": onlineTaxableAmount,
          "Logistics Amount": logisticsOrderAmount,
          "Logistics Taxable Amount": logisticsTaxableAmount,
          "Commission Percent Online": commissionPercentOnlineProduct,
          "Commission Online": parseFloat(onlineCommission) + parseFloat(logisticsCommission),
          "Offline Sale Amount": data.offline_sale_id && data.offline_sale_product_datum 
                                  ? safeNumber(data.offline_sale_product_datum.sale_amount) 
                                  : 0,
          "Offline Taxable Amount": offlineTaxableAmount,
          "Commission Percent Offline": commissionPercentOfflineProduct,
          "Commission Offline": offlineCommission,
          "Service Sale Amount": data.service_id ? safeNumber(data.order_price) : 0,
          "Service Taxable Amount": serviceTaxableAmount,
          "Commission Percent Service Sale": commissionPercentService,
          "Commission Service": serviceCommission,
          "Commission": totalCommission.toFixed(2),
          "TDS": tds.toFixed(2),
          "Net Receivable": netReceivable.toFixed(2)
      };
  });
    
  const handleExportCSVs = () => {
    exportToCSV(dataOther, commissionType === 'retainer' ? "retainer order details" : "sale/Retail order details");
  }
    
  const handleExportExcels = () => {
    exportToExcel(dataOther, commissionType === 'retainer' ? "retainer order details" : "sale/Retail order details");
  }
    
  const handleExportPDFs = () => {
    exportToPDF(dataOther, commissionType === 'retainer' ? "retainer order details" : "sale/Retail order details");
  }
  
  const getMainColumns = (commissionType, fetchDonePayments) => {
    const base = [
      { header: "Reg Id", accessor: "reg_id", sortable: true, filter: true },
      { header: "First Name", accessor: "first_name", sortable: true, filter: true },
      { header: "Middle Name", accessor: "middle_name", sortable: true, filter: true },
      { header: "Last Name", accessor: "last_name", sortable: true, filter: true },
      { header: "Bank Account No", accessor: "bank_account_no", sortable: true, filter: true },
      { header: "Bank Name", accessor: "bank_name", sortable: true, filter: true },
      { header: "IFSC Code", accessor: "ifsc_code", sortable: true, filter: true },
    ];

    if (commissionType == "retainer") {
      return [
        ...base,
        {
          header: "Retainer Total Shopping Online Product",
          accessor: "retainer_total_order_amount_online",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_total_order_amount_online, "float"),
        },
        {
          header: "Retainer Total Taxable Shopping Online Product",
          accessor: "retainer_total_taxable_order_amount_online",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_total_taxable_order_amount_online, "float"),
        },
        {
          header: "Retainer Total Shopping Offline Product",
          accessor: "retainer_total_order_amount_offline",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_total_order_amount_offline, "float"),
        },
        {
          header: "Retainer Total Taxable Shopping Offline Product",
          accessor: "retainer_total_taxable_order_amount_offline",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_total_taxable_order_amount_offline, "float"),
        },
        {
          header: "Retainer Total Shopping Service",
          accessor: "retainer_total_order_amount_service",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_total_order_amount_service, "float"),
        },
        {
          header: "Retainer Total Taxable Shopping Service",
          accessor: "retainer_total_taxable_order_amount_service",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_total_taxable_order_amount_service, "float"),
        },
        { header: "Refer Reg Id", accessor: "refer_reg_id", sortable: true, filter: true },
        { header: "Refer First Name", accessor: "refer_first_name", sortable: true, filter: true },
        { header: "Refer Middle Name", accessor: "refer_middle_name", sortable: true, filter: true },
        { header: "Refer Last Name", accessor: "refer_last_name", sortable: true, filter: true },
        {
          header: "Total Shopping Online Product",
          accessor: "retainer_order_amount_online",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_order_amount_online, "float"),
        },
        {
          header: "Total Taxable Shopping Online Product",
          accessor: "retainer_taxable_order_amount_online",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_taxable_order_amount_online, "float"),
        },
        {
          header: "Commission Percent Online Product",
          accessor: "retainer_commission_percent_online",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_commission_percent_online, "float"),
        },
        {
          header: "Commission Online Product",
          accessor: "retainer_commission_online",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_commission_online, "float"),
        },
        {
          header: "Total Shopping Offline Product",
          accessor: "retainer_order_amount_offline",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_order_amount_offline, "float"),
        },
        {
          header: "Total Taxable Shopping Offline Product",
          accessor: "retainer_taxable_order_amount_offline",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_taxable_order_amount_offline, "float"),
        },
        {
          header: "Commission Percent Offline Product",
          accessor: "retainer_commission_percent_offline",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_commission_percent_offline, "float"),
        },
        {
          header: "Commission Offline Product",
          accessor: "retainer_commission_offline",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_commission_offline, "float"),
        },
        {
          header: "Total Shopping Service",
          accessor: "retainer_order_amount_service",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_order_amount_service, "float"),
        },
        {
          header: "Total Taxable Shopping Service",
          accessor: "retainer_taxable_order_amount_service",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_taxable_order_amount_service, "float"),
        },
        {
          header: "Commission Percent Service",
          accessor: "retainer_commission_percent_service",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_commission_percent_service, "float"),
        },
        {
          header: "Commission Service",
          accessor: "retainer_commission_service",
          sortable: true,
          filter: true,
          render: (row) => parseValue(row.retainer_commission_service, "float"),
        },
        {
          header: "Total Commission",
          accessor: "total_commission",
          render: (row) => {
            const online = +row.retainer_commission_online || 0;
            const offline = +row.retainer_commission_offline || 0;
            const service = +row.retainer_commission_service || 0;
            return (online + offline + service).toFixed(2);
          },
        },
        {
          header: "TDS",
          accessor: "tds",
          render: (row) => {
            const total = +row.total_commission || 0;
            return (total * row.tds_percent).toFixed(2);
          },
        },
        {
          header: "Receivable Commission",
          accessor: "receivable_commission",
          render: (row) => {
            const total = +row.total_commission || 0;
            const tds = +row.tds || 0;
            return (total - tds).toFixed(2);
          },
        },
        {
          header: "Actions",
          accessor: "actions",
          render: (row) => (
            <button
              className="btn btn-primary btn-sm"
              onClick={() =>
                getOrderDetails(
                  row.order_item_ids,
                  row.retainer_commission_percent_online,
                  row.retainer_commission_percent_offline,
                  row.retainer_commission_percent_service,
                  "retainer",
                  row.tds_percent
                )
              }
            >
              View Order Details
            </button>
          ),
        },
      ];
    }

    return [
      ...base,
      {
        header: "User Total Taxable Amount",
        accessor: "total_user_shopping_amount_taxable",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_user_shopping_amount_taxable, "float"),
      },
      { header: "Variant", accessor: "variant", sortable: true, filter: true },
      {
        header: "Total Shopping Online Product",
        accessor: "total_shopping_online_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_shopping_online_product, "float"),
      },
      {
        header: "Total Taxable Shopping Online Product",
        accessor: "total_taxable_shopping_online_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_taxable_shopping_online_product, "float"),
      },
      {
        header: "Commission Percent Online Product",
        accessor: "commission_percent_online_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.commission_percent_online_product, "float"),
      },
      {
        header: "Total Shopping Offline Product",
        accessor: "total_shopping_offline_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_shopping_offline_product, "float"),
      },
      {
        header: "Total Taxable Shopping Offline Product",
        accessor: "total_taxable_shopping_offline_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_taxable_shopping_offline_product, "float"),
      },
      {
        header: "Commission Percent Offline Product",
        accessor: "commission_percent_offline_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.commission_percent_offline_product, "float"),
      },
      {
        header: "Total Shopping Service",
        accessor: "total_shopping_service",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_shopping_service, "float"),
      },
      {
        header: "Total Taxable Shopping Service",
        accessor: "total_taxable_shopping_service",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_taxable_shopping_service, "float"),
      },
      {
        header: "Commission Percent Service",
        accessor: "commission_percent_service",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.commission_percent_service, "float"),
      },
      {
        header: "Total Order Amount Shopping Online Product",
        accessor: "total_order_amount_shopping_online_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_order_amount_shopping_online_product, "float"),
      },
      {
        header: "Total Taxable Order Amount Shopping Online Product",
        accessor: "total_taxable_amount_shopping_online_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_taxable_amount_shopping_online_product, "float"),
      },
      {
        header: "Commission Shopping Online Product",
        accessor: "commission_shopping_online_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.commission_shopping_online_product, "float"),
      },
      {
        header: "Total Order Amount Shopping Offline Product",
        accessor: "total_order_amount_shopping_offline_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_order_shopping_offline_product, "float"),
      },
      {
        header: "Total Taxable Amount Shopping Offline Product",
        accessor: "total_taxable_amount_shopping_offline_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_taxable_amount_shopping_offline_product, "float"),
      },
      {
        header: "Commission Shopping Offline Product",
        accessor: "commission_shopping_offline_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.commission_shopping_offline_product, "float"),
      },
      {
        header: "Total Order Amount Shopping Service",
        accessor: "total_order_amount_shopping_service",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_order_amount_shopping_service, "float"),
      },
      {
        header: "Total Taxable Amount Shopping Service",
        accessor: "total_taxable_amount_shopping_service",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_taxable_amount_shopping_service, "float"),
      },
      {
        header: "Commission Shopping Service",
        accessor: "commission_shopping_service",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.commission_shopping_service, "float"),
      },
      {
        header: "TDS Shopping",
        accessor: "shopping_tds",
        render: (row) => {
          const online = +row.commission_shopping_online_product || 0;
          const offline = +row.commission_shopping_offline_product || 0;
          const service = +row.commission_shopping_service || 0;
          return ((online + offline + service) * row.tds_percent).toFixed(2);
        },
      },
      {
        header: "Receivable Shopping",
        accessor: "shopping_receiveable",
        render: (row) => {
          const online = +row.commission_shopping_online_product || 0;
          const offline = +row.commission_shopping_offline_product || 0;
          const service = +row.commission_shopping_service || 0;
          const total = online + offline + service;
          return (total - total * row.tds_percent).toFixed(2);
        },
      },
      {
        header: "Total Order Amount Retail Online Product",
        accessor: "total_order_amount_retail_online_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_order_amount_retail_online_product, "float"),
      },
      {
        header: "Total Taxable Amount Retail Online Product",
        accessor: "total_taxable_amount_retail_online_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_taxable_amount_retail_online_product, "float"),
      },
      {
        header: "Commission Percent Retail Online Product",
        accessor: "commission_percent_retail_online_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.commission_percent_retail_online_product, "float"),
      },
      {
        header: "Commission Retail Online Product",
        accessor: "commission_retail_online_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.commission_retail_online_product, "float"),
      },
      {
        header: "Total Order Amount Retail Offline Product",
        accessor: "total_order_amount_retail_offline_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_order_amount_retail_offline_product, "float"),
      },
      {
        header: "Total Taxable Amount Retail Offline Product",
        accessor: "total_taxable_amount_retail_offline_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_taxable_amount_retail_offline_product, "float"),
      },
      {
        header: "Commission Percent Retail Offline Product",
        accessor: "commission_percent_retail_offline_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.commission_percent_retail_offline_product, "float"),
      },
      {
        header: "Commission Retail Offline Product",
        accessor: "commission_retail_offline_product",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.commission_retail_offline_product, "float"),
      },
      {
        header: "Total Order Amount Retail Service",
        accessor: "total_order_amount_retail_service",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_order_amount_retail_service, "float"),
      },
      {
        header: "Total Taxable Amount Retail Service",
        accessor: "total_taxable_amount_retail_service",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.total_taxable_amount_retail_service, "float"),
      },
      {
        header: "Commission Percent Retail Service",
        accessor: "commission_percent_retail_service",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.commission_percent_retail_service, "float"),
      },
      {
        header: "Commission Retail Service",
        accessor: "commission_retail_service",
        sortable: true,
        filter: true,
        render: (row) => parseValue(row.commission_retail_service, "float"),
      },
      {
        header: "TDS Retail",
        accessor: "retail_tds",
        render: (row) => {
          const online = +row.commission_retail_online_product || 0;
          const offline = +row.commission_retail_offline_product || 0;
          const service = +row.commission_retail_service || 0;
          return ((online + offline + service) * row.tds_percent).toFixed(2);
        },
      },
      {
        header: "Receivable Retail",
        accessor: "retail_receiveable",
        render: (row) => {
          const online = +row.commission_retail_online_product || 0;
          const offline = +row.commission_retail_offline_product || 0;
          const service = +row.commission_retail_service || 0;
          const total = online + offline + service;
          return (total - total * row.tds_percent).toFixed(2);
        },
      },
      {
        header: "Actions",
        accessor: "actions",
        render: (row) => (
          <div className="d-flex flex-column">
            {row.order_item_ids_shopping && (
              <button
                className="btn btn-primary btn-sm mb-2"
                onClick={() =>
                  getOrderDetails(
                    row.order_item_ids_shopping,
                    row.commission_percent_online_product,
                    row.commission_percent_offline_product,
                    row.commission_percent_service,
                    "shopping",
                    row.tds_percent
                  )
                }
              >
                View Shopping Order Details
              </button>
            )}
            {row.order_item_ids_retail && (
              <button
                className="btn btn-primary btn-sm"
                onClick={() =>
                  getOrderDetails(
                    row.order_item_ids_retail,
                    row.commission_percent_retail_online_product,
                    row.commission_percent_retail_offline_product,
                    row.commission_percent_retail_service,
                    "retail",
                    row.tds_percent
                  )
                }
              >
                View Retail Order Details
              </button>
            )}
          </div>
        ),
      },
    ];
  };


  const orderDetailsColumns = [
  {
    header: "Order Id",
    accessor: "order_id",
    sortable: true,
    filter: true,
    render: row => row.order?.order_id || "NA"
  },
  {
    header: "Reg Id",
    accessor: "reg_id",
    sortable: true,
    filter: true,
    render: row => row.order?.user?.reg_id || "NA"
  },
  {
    header: "Order Date",
    accessor: "order_date",
    sortable: true,
    filter: true,
    render: row => row.order?.created_at || "NA"
  },
  {
    header: "Invoice No",
    accessor: "invoice_no",
    sortable: true,
    filter: true,
    render: row => {
      const invoices = row.order?.invoices || [];
      const type = ["shopping", "retainer"].includes(orderDetailsType) ? "product" : "seller_product";
      return invoices.find(inv => inv.invoice_type === type)?.invoice_no || "NA";
    }
  },
  {
    header: "No Return Date",
    accessor: "no_return_date",
    sortable: true,
    filter: true,
    render: row => row.no_return_date || null
  },
  {
    header: "Product/Service Name",
    accessor: "product_name",
    sortable: true,
    filter: true,
    render: row =>
      row.product_item?.product?.name ||
      row.offline_sale_product_datum?.product_description ||
      row.seller_service?.service_name ||
      "NA"
  },
  {
    header: "Online Sale Amount",
    accessor: "online_sale_amount",
    sortable: true,
    filter: true,
    render: row => (row.product_id ? row.order_price : 0)
  },
  {
    header: "Online Taxable Amount",
    accessor: "online_taxable_amount",
    sortable: true,
    filter: true,
    render: row => (row.product_id ? row.taxable_amount : 0)
  },
  {
    header: "Logistics Amount",
    accessor: "logistics_amount",
    sortable: true,
    filter: true,
    render: row => {
      const lo = row.logistics_order || row.logistics_orders?.[0] || {};
      const count = lo.order_item_id?.split(",").length || 0;
      return safeDivide(safeNumber(lo.order_price), count);
    }
  },
  {
    header: "Logistics Taxable Amount",
    accessor: "logistics_taxable_amount",
    sortable: true,
    filter: true,
    render: row => {
      const lo = row.logistics_order || row.logistics_orders?.[0] || {};
      const count = lo.order_item_id?.split(",").length || 0;
      return safeDivide(safeNumber(lo.taxable_value), count);
    }
  },
  {
    header: "Commission Percent Online",
    accessor: "commission_percent_online",
    sortable: true,
    filter: true,
    render: row => (row.product_id ? commissionPercentOnlineProduct : 0)
  },
  {
    header: "Commission Online",
    accessor: "commission_online",
    sortable: true,
    filter: true,
    render: row => {
      const t = safeNumber(row.taxable_amount);
      const lo = row.logistics_order || row.logistics_orders?.[0] || {};
      const count = lo.order_item_id?.split(",").length || 0;
      const logTax = safeDivide(safeNumber(lo.taxable_value), count);
      const pct = row.product_id ? commissionPercentOnlineProduct : 0;
      return ((t * pct) / 100 + (logTax * commissionPercentService) / 100).toFixed(2);
    }
  },
  {
    header: "Offline Sale Amount",
    accessor: "offline_sale_amount",
    sortable: true,
    filter: true,
    render: row => (row.offline_sale_id && row.offline_sale_product_datum ? row.offline_sale_product_datum.sale_amount : 0)
  },
  {
    header: "Offline Taxable Amount",
    accessor: "offline_taxable_amount",
    sortable: true,
    filter: true,
    render: row => (row.offline_sale_id && row.offline_sale_product_datum ? row.offline_sale_product_datum.taxable_supply : 0)
  },
  {
    header: "Commission Percent Offline",
    accessor: "commission_percent_offline",
    sortable: true,
    filter: true,
    render: row => (row.offline_sale_id ? commissionPercentOfflineProduct : 0)
  },
  {
    header: "Commission Offline",
    accessor: "commission_offline",
    sortable: true,
    filter: true,
    render: row => {
      const t = safeNumber(row.taxable_amount);
      const pct = row.offline_sale_id ? commissionPercentOfflineProduct : 0;
      return ((t * pct) / 100).toFixed(2);
    }
  },
  {
    header: "Service Sale Amount",
    accessor: "service_sale_amount",
    sortable: true,
    filter: true,
    render: row => (row.service_id ? row.order_price : 0)
  },
  {
    header: "Service Taxable Amount",
    accessor: "service_taxable_amount",
    sortable: true,
    filter: true,
    render: row => (row.service_id ? safeNumber(row.taxable_amount) : 0)
  },
  {
    header: "Commission Percent Service",
    accessor: "commission_percent_service",
    sortable: true,
    filter: true,
    render: row => (row.service_id || row.logistics_order || row.logistics_orders?.length ? commissionPercentService : 0)
  },
  {
    header: "Commission Service",
    accessor: "commission_service",
    sortable: true,
    filter: true,
    render: row => {
      const t = safeNumber(row.taxable_amount);
      const pct = row.service_id ? commissionPercentService : 0;
      return ((t * pct) / 100).toFixed(2);
    }
  },
  {
    header: "Commission",
    accessor: "commission",
    sortable: true,
    filter: true,
    render: row => {
      const t = safeNumber(row.taxable_amount);
      const lo = row.logistics_order || row.logistics_orders?.[0] || {};
      const count = lo.order_item_id?.split(",").length || 0;
      const logTax = safeDivide(safeNumber(lo.taxable_value), count);
      const pct = row.product_id
        ? commissionPercentOnlineProduct
        : row.offline_sale_id
        ? commissionPercentOfflineProduct
        : commissionPercentService;
      return ((t * pct) / 100 + (logTax * commissionPercentService) / 100).toFixed(2);
    }
  },
  {
    header: "TDS",
    accessor: "tds",
    sortable: true,
    filter: true,
    render: row => {
      const t = safeNumber(row.taxable_amount);
      const lo = row.logistics_order || row.logistics_orders?.[0] || {};
      const count = lo.order_item_id?.split(",").length || 0;
      const logTax = safeDivide(safeNumber(lo.taxable_value), count);
      const pct = row.product_id
        ? commissionPercentOnlineProduct
        : row.offline_sale_id
        ? commissionPercentOfflineProduct
        : commissionPercentService;
      const comm = t * pct / 100 + logTax * commissionPercentService / 100;
      return (comm * tdsPercent).toFixed(2);
    }
  },
  {
    header: "Net Receivable",
    accessor: "net_receivable",
    sortable: true,
    filter: true,
    render: row => {
      const t = safeNumber(row.taxable_amount);
      const lo = row.logistics_order || row.logistics_orders?.[0] || {};
      const count = lo.order_item_id?.split(",").length || 0;
      const logTax = safeDivide(safeNumber(lo.taxable_value), count);
      const pct = row.product_id
        ? commissionPercentOnlineProduct
        : row.offline_sale_id
        ? commissionPercentOfflineProduct
        : commissionPercentService;
      const comm = t * pct / 100 + logTax * commissionPercentService / 100;
      const tds = comm * tdsPercent;
      return (comm - tds).toFixed(2);
    }
  }
] ;


  const handleMonthOrYearChange = () => {
    const month = parseInt(document.getElementById("month_selector").value);
    const year = parseInt(document.getElementById("year_selector").value);

    if (!isNaN(month) && !isNaN(year)) {
        const startDate = moment({ year, month: month - 1, day: 1 });
        const endDate = moment(startDate).endOf('month');

        document.getElementById("start_date").value = startDate.format('YYYY-MM-DD');
        document.getElementById("end_date").value = endDate.format('YYYY-MM-DD');
    }
  };

  return (
    <>
          
            <h1>Buyer Commissions</h1>
            <br />
            <div className='row'>
              <div className='col-md-3'>
                <label>Select Month</label>
                <select className='form-control' id="month_selector" onChange={handleMonthOrYearChange}>
                    <option value="">-- Select Month --</option>
                    {Array.from({ length: 12 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>
                            {new Date(0, i).toLocaleString('default', { month: 'long' })}
                        </option>
                    ))}
                </select>
              </div>

              <div className='col-md-3'>
                <label>Select Year</label>
                <select className='form-control' id="year_selector" onChange={handleMonthOrYearChange}>
                    <option value="">-- Select Year --</option>
                    {Array.from({ length: new Date().getFullYear() - 2025 + 1 }, (_, i) => {
                        const year = 2025 + i;
                        return (
                            <option key={year} value={year}>{year}</option>
                        );
                    })}
                </select>
              </div>

              <input type='hidden' id="start_date" />
              <input type='hidden' id="end_date" />

              <div className='col-md-3'>
                  <label>Commission Type</label>
                  <select id="commission_type" className='form-control'>
                      <option value="">Select Commission Type</option>
                      <option value="sale_retail">Sale/Retail Commission</option>
                      <option value="retainer">Retainer Commission</option>
                  </select>
              </div>
              <div className='col-md-3'>
                  <br/>
                  <button type="button" className='btn btn-primary btn-sm mt-2' id='submit_button' onClick={fetchUserCommissions}>Submit</button>
              </div>
              <div className='col-md-12 mt-3'>
                <input type='radio' name='fetch_option' id="all" defaultChecked /> Fetch All&nbsp;&nbsp;
                <input type='radio' name='fetch_option' id="fetch_approved" /> Fetch Approved&nbsp;&nbsp;
                <input type='radio' name='fetch_option' id="fetch_done_payments" /> Fetch Done Payments
              </div>
              <div className='col-md-12 mt-3'>
                <button className='btn btn-primary me-2' onClick={() => exportToCSV(commissionType === 'retainer' ? retainerColumnDefsdata : saleRetailColumnDefsdata, commissionType === 'retainer' ? "retainer commission" : "sale/Retail commission")}>Export to CSV</button>
                <button className='btn btn-primary me-2' onClick={() => exportToExcel(commissionType === 'retainer' ? retainerColumnDefsdata : saleRetailColumnDefsdata, commissionType === 'retainer' ? "retainer commission" : "sale/Retail commission")}>Export to Excel</button>
                <button className='btn btn-primary' onClick={() => exportToPDF(commissionType === 'retainer' ? retainerColumnDefsdata : saleRetailColumnDefsdata, commissionType === 'retainer' ? "retainer commission" : "sale/Retail commission")}>Export to PDF</button>
              </div>
            </div>
            <br/>
            <div className="ag-theme-alpine" style={{height: '600px', width: '100%'}}>
            <Table 
                key={commissionType}
                columns={getMainColumns(commissionType)}
                data={userCommissions}
                {...(!$('#fetch_done_payments').is(':checked') && { onSelectionChange: addToPaymentList })}
            />
            </div>
            <br/>
            <>
            {
                approveButton ? 
                    <center><button type='button' className='btn btn-success btn-sm' id="approve-button" onClick={approvePayment}>Approve</button></center>
                : ""
            }
            {
                pushPaymentButton ? 
                    <center><button type='button' className='btn btn-success btn-sm' id="push-payment-button" onClick={() => setAddPaymentDate(!addPaymentDate)}>Mark as payment done</button></center>
                : ""
            }
            </>
            
            <Modal isOpen={modal} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>Order Details</ModalHeader>
                <ModalBody>
                <div className="mb-3">
                        <button className='btn btn-secondary me-2' onClick={handleExportCSVs}>Export to CSV</button>
                        <button className='btn btn-secondary me-2' onClick={handleExportExcels}>Export to Excel</button>
                        <button className='btn btn-secondary' onClick={handleExportPDFs}>Export to PDF</button>
                    </div>
                    
                    <div className="ag-theme-alpine" style={{height: '400px', width: '100%'}}>
                        <Table 
                            columns={orderDetailsColumns}
                            data={orderDetails}
                        />
                    </div>
                </ModalBody>
            </Modal>

            <Modal isOpen={addPaymentDate} toggle={() => setAddPaymentDate(!addPaymentDate)} size="md">
                <ModalHeader toggle={() => setAddPaymentDate(!addPaymentDate)}>Add Payment Date</ModalHeader>
                <ModalBody>
                    <input type='datetime-local' id='payment-date' className='form-control' defaultValue={moment().seconds(0).format('YYYY-MM-DDTHH:mm')} max={moment().seconds(0).format('YYYY-MM-DDTHH:mm')}/><br/>
                    <button type='button' className='btn btn-success btn-sm' onClick={() => updatePaymentDate()}>Save</button>
                </ModalBody>
            </Modal>
        </>
  )
}

export default BuyerCommission;